export const initPopups = () => {
    var currentPopup;
    document.addEventListener("click", function (e) {
        if (e.target.classList.contains("show-modal")) {
            let modalId = e.target.dataset["target"];
            currentPopup = document.querySelector(modalId);
            currentPopup.classList.add("show");
            e.preventDefault();
        }

        if (
            e.target.classList.contains("bm-wp-theme-popup") ||
            e.target.classList.contains("bm-wp-theme-popup-close")
        ) {
            currentPopup.classList.remove("show");
        }
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && currentPopup) {
            currentPopup.classList.remove("show");
        }
    });
};
